<script>
import { BCardFooter } from "bootstrap-vue";

export default {
  extends: BCardFooter
};
</script>